import React from "react";

import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import { EntityType, Territory } from "@mapmycustomers/shared/types/entity";
import { EntityTypeIcon } from "@mapmycustomers/ui";

import EntityTag from "@app/component/EntityTag";
import ListWithOverflowItem from "@app/component/ListWithOverflowItem";
import Path from "@app/enum/Path";

import styles from "./Territories.module.scss";

interface Props {
  territories?: Pick<Territory, "color" | "id" | "name">[];
}

const Territories: React.FC<Props> = ({ territories }) => {
  const intl = useIntl();

  if (!territories?.length) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {intl.formatMessage(
          {
            id: "recordPane.territories.title",
            defaultMessage: "{icon} Territory",
            description: "Territory list section in a record preview pane",
          },
          { icon: <EntityTypeIcon entityType={EntityType.TERRITORY} /> }
        )}
      </div>
      <ListWithOverflowItem className={styles.list}>
        {(territories ?? []).map((territory) => (
          <a
            className={styles.link}
            href={`${Path.MAP}/territories/${territory.id}`}
            key={territory.id}
            rel="noreferrer"
            target="_blank"
          >
            <Tooltip
              title={intl.formatMessage({
                id: "recordPane.territories.item.tooltip",
                defaultMessage: "Open Territory",
                description:
                  "Tooltip for territory in Territory list section in a record preview pane",
              })}
            >
              <EntityTag entity={territory} />
            </Tooltip>
          </a>
        ))}
      </ListWithOverflowItem>
    </div>
  );
};

export default Territories;
